import { type Common } from './common.js';
import {
  type CreateValues,
  type EhrSystem,
  type FindAllOptions,
  type UpdateValues,
} from './models/ehrSystem.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint = '/ehr-systems';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<EhrSystem>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options?: { organizationId?: string }): Promise<EhrSystem[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    const { ehrSystems } = await this.common.getJSON(url);
    return ehrSystems;
  }

  async findOneById(id: string): Promise<EhrSystem> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { ehrSystem } = await this.common.getJSON(url);
    return ehrSystem;
  }

  async create(toAdd: CreateValues): Promise<EhrSystem> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    const { ehrSystem } = await this.common.postJSON(url, toAdd);
    return ehrSystem;
  }

  async update(id: string, toUpdate: UpdateValues): Promise<EhrSystem> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { ehrSystem } = await this.common.patchJSON(url, toUpdate);
    return ehrSystem;
  }

  async remove(id: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }
}
